// this component is subject to decommisioning
import React, { useCallback, useState } from 'react';
import SweetAlert from 'sweetalert-react';
import { miniGazelle, isExternal } from '../../../helpers';
import FormComposer from '../../shared/Forms/FormComposer/FormComposer';
import request from '../../../http/request';
import { getUrl } from '../../../helpers';
import './ResetPasswordTrigger.scss';

const ResetPasswordTrigger = props => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState(null);

    const register = useCallback((action, formData, cb) => {
        const url = `${getUrl()}${action}`;
        let fetch = request
            .post(url)
            .send(formData)
            .then(res => {
                setError(false);
                setLoading(false);
                setSuccess(true);
                setRedirectUrl(res.body.target);
                cb();
            })
            .catch(err => {
                setError(true);
                setLoading(false);
                setSuccess(false);
                console.warn(err);
                cb();
            });
        return fetch;
    });

    const redirectUser = target => {
        let targetUrl;
        if (isExternal(target)) {
            targetUrl = target;
        } else {
            targetUrl = `${getUrl()}${target}`;
        }
        window.location.href = targetUrl;
    };

    /**
     * standard props used in the style / function of the module.
     * Null if not specified
     **/
    const logicalName = props.data?.logicalName || null;
    /**
     * props specific to this module
     **/
    const formData = props.data?.form;

    const onConfirmSuccess = useCallback(() => {
        setError(false);
        setSuccess(false);
        redirectUser(redirectUrl);
    });

    const onConfirmError = useCallback(() => {
        setError(false)
    })

    return (
        <div className="container-fluid module resetpasswordtrigger" id={logicalName}>
            <div className="container">
                <div className="col-lg-12 text-left">
                    <h1>{miniGazelle.label('resetPasswordTriggerTitle', true)}</h1>
                </div>
                <div className="rpt-top-inner offset-lg-3 col-lg-6">
                    <p>{miniGazelle.label('resetPasswordTriggerContent', true)}</p>
                </div>
            </div>
            {/* the form */}
            <div className="rpt-inner rpt-form-wrapper">
                <div className="container">
                    <div className="col-lg-6 offset-lg-3 privacy-statement inner-content">
                        <FormComposer {...formData} name={props.name} sendForm={register} />
                    </div>
                </div>
            </div>
            {/* alerts */}
            <SweetAlert
                type="error"
                show={error}
                title={miniGazelle.label('errorTriggerResetTitle', true)}
                text={miniGazelle.label('errorTriggerReset', true)}
                onConfirm={onConfirmError}
            />
            {/* alerts */}
            <SweetAlert
                type="success"
                show={success}
                title={miniGazelle.label('successTriggerResetTitle', true)}
                text={miniGazelle.label('successTriggerReset', true)}
                onConfirm={onConfirmSuccess}
            />
        </div>
    );
};

export default ResetPasswordTrigger;
